import { render, staticRenderFns } from "./TrainingPlanItemNutrition.vue?vue&type=template&id=58654d8a&scoped=true&"
import script from "./TrainingPlanItemNutrition.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemNutrition.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemNutrition.vue?vue&type=style&index=0&id=58654d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58654d8a",
  null
  
)

export default component.exports